import { render, staticRenderFns } from "./ItemizedPrice.vue?vue&type=template&id=08f25044"
import script from "./ItemizedPrice.vue?vue&type=script&lang=js"
export * from "./ItemizedPrice.vue?vue&type=script&lang=js"
import style0 from "./ItemizedPrice.vue?vue&type=style&index=0&id=08f25044&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VDivider,VIcon,VSpacer})
